import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['counter']
  static values = { url: String, seconds: Number }

  connect () {
    this.timer = setInterval(() => this.tick(), 1000)
    window.addEventListener('pagehide', this.stop)
  }

  disconnect () {
    this.stop()
    window.removeEventListener('pagehide', this.stop)
  }

  // Private

  stop = () => clearInterval(this.timer)

  tick () {
    this.secondsValue -= 1

    if (this.secondsValue > 0) {
      this.counterTarget.textContent = this.secondsValue
    } else {
      this.stop()
      window.location.href = this.urlValue
    }
  }
}
